//测试列表
export const SK_TEST_LIST = 'sk_test_list'
//测试详情
export const SK_TEST_DETAILS = 'sk_test_details'
//测试结束
export const SK_TESTT_END = 'sk_testt_end'
//测试推送
export const SK_TESTT_EDIT = 'sk_testt_edit'


// WEBPACK FOOTER //
// ./src/store/give-course/test/type.js